module.exports = __webpack_public_path__ + "static/media/再想想@2x.c90840d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/再想想@2x.png
// module id = 1248
// module chunks = 0